<div class="row">
  <div class="col-md-12">
    <h4>Available Fee Schedules</h4>
  </div>
</div>

<div class="row">
  <div class="col-md-12">
    <app-grid-wrapper #available [gridSize]="GridSize.small" (cellDoubleClicked)="select()">
      <button
        type="button"
        class="btn btn-default"
        [disabled]="!availableSelection"
        (click)="select()"
      >
        <i class="fa fa-plus"></i> Select
      </button>
    </app-grid-wrapper>
  </div>
</div>

<div class="panel panel-default">
  <div class="panel-body panel-body-dark">
    <app-entity-group-edit-feeschedule-timeline
      [(entityGroupFeeSchedules)]="entityGroupFeeSchedules"
      (viewDetails)="viewDetails($event)"
    ></app-entity-group-edit-feeschedule-timeline>
  </div>
</div>
